import React from 'react';
import { View, ViewStyle } from 'react-native';

export interface TableBodyProps {
  children: React.ReactNode;
  style?: ViewStyle;
}

export const TableBody: React.FC<TableBodyProps> = ({ children, style }) => {
  return (
    <View role="rowgroup" style={style}>
      {children}
    </View>
  );
};
